<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="rk-question">
        <span class="rk-bar rk-bar--xl"></span>
      </div>
      <div class="rk-list">
        <div
          v-for="(item, i) in items"
          :key="item.label"
          class="rk-row"
          :style="{ '--row-i': i }"
        >
          <span class="rk-rank">{{ i + 1 }}</span>
          <div class="rk-content">
            <span class="rk-label">{{ item.label }}</span>
            <div class="rk-track">
              <div
                class="rk-fill"
                :style="{ '--row-pct': item.pct + '%', '--row-i': i }"
              ></div>
            </div>
          </div>
          <span class="rk-score">{{ item.score }}</span>
        </div>
      </div>
    </template>

    <template #audience>
      <span class="rk-phone-q"></span>
      <div
        v-for="(item, i) in items"
        :key="item.label"
        class="rk-phone-item"
        :class="{ '--dragging': i === 0 }"
        :style="{ '--row-i': i }"
      >
        <span class="material-symbols-rounded rk-phone-grip">drag_indicator</span>
        <span class="rk-phone-num">{{ i + 1 }}</span>
        <span class="rk-phone-label">{{ item.label }}</span>
      </div>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewRanking',
  components: { PreviewFrame },
  props: {
    slide: { type: Object as PropType<SlideType>, required: true },
  },
  data() {
    return {
      items: [
        { label: 'Mobile app', pct: 92, score: 4.6 },
        { label: 'Onboarding', pct: 70, score: 3.8 },
        { label: 'API docs', pct: 48, score: 2.9 },
        { label: 'Settings UI', pct: 32, score: 2.1 },
      ],
    }
  },
})
</script>

<style scoped lang="scss">
.rk-bar {
  display: block; height: 8px; border-radius: 999px;
  background: rgba(15, 15, 20, 0.2);
  width: 70%;
}
.rk-question {
  padding-bottom: 6px;
  border-bottom: 1px dashed color-mix(in srgb, var(--accent) 20%, transparent);
}

.rk-list { display: grid; gap: 7px; }
.rk-row {
  display: grid;
  grid-template-columns: 18px 1fr auto;
  align-items: center;
  gap: 8px;
}
.rk-rank {
  width: 18px; height: 18px;
  border-radius: 999px;
  background: var(--accent); color: white;
  font-size: 10px; font-weight: 700;
  display: grid; place-items: center;
}
.rk-content { display: grid; gap: 3px; }
.rk-label {
  font-size: 10px; font-weight: 700;
  color: rgba(15, 15, 20, 0.7);
}
.rk-track {
  height: 8px; border-radius: 999px;
  background: rgba(15, 15, 20, 0.06);
  overflow: hidden;
}
.rk-fill {
  height: 100%; width: 0;
  border-radius: 999px;
  background: var(--accent);
  animation: rk-grow 4s cubic-bezier(0.23, 1, 0.32, 1) infinite;
  animation-delay: calc(var(--row-i, 0) * 100ms + 700ms);
}
.rk-score {
  font-size: 10px; font-weight: 700;
  color: var(--accent);
  font-variant-numeric: tabular-nums;
  min-width: 22px; text-align: right;
}

/* ---- Audience phone ---- */
.rk-phone-q {
  display: block; height: 8px; border-radius: 999px;
  width: 70%; background: rgba(15, 15, 20, 0.18);
  margin-bottom: 4px;
}
.rk-phone-item {
  display: grid;
  grid-template-columns: 14px 16px 1fr;
  align-items: center;
  gap: 6px;
  padding: 7px 8px;
  border-radius: 6px;
  border: 1px solid rgba(15, 15, 20, 0.08);
  background: white;
}
.rk-phone-grip {
  font-size: 14px;
  color: rgba(15, 15, 20, 0.4);
}
.rk-phone-num {
  width: 16px; height: 16px;
  border-radius: 999px;
  background: var(--accent); color: white;
  font-size: 9px; font-weight: 700;
  display: grid; place-items: center;
}
.rk-phone-label {
  font-size: 11px; font-weight: 600;
  color: rgba(15, 15, 20, 0.75);
}
.rk-phone-item.--dragging {
  border-color: var(--accent);
  background: color-mix(in srgb, var(--accent) 8%, white);
  animation: rk-drag 4s cubic-bezier(0.23, 1, 0.32, 1) infinite;
  box-shadow: 0 4px 12px -4px rgba(15, 15, 20, 0.2);
}

@keyframes rk-grow {
  0%, 12% { width: 0; }
  60%     { width: var(--row-pct, 50%); }
  92%, 100% { width: var(--row-pct, 50%); }
}
@keyframes rk-drag {
  0%, 8%  { transform: translateY(0); }
  25%     { transform: translateY(-4px); }
  50%     { transform: translateY(-8px); }
  75%     { transform: translateY(-4px); }
  100%    { transform: translateY(0); }
}

@media (prefers-reduced-motion: reduce) {
  .rk-fill { animation: none; width: var(--row-pct, 50%); }
  .rk-phone-item.--dragging { animation: none; }
}
</style>
